import dayjs from "dayjs";

const isTodayGreaterThanMoralTaxesCalcLimitDate = () => {
  const today = dayjs();
  const targetDate = dayjs("2025-02-01", "YYYY-MM-DD"); // Adjusted format to match Month/Day/Year
  return today.isAfter(targetDate);
};

export { isTodayGreaterThanMoralTaxesCalcLimitDate };
